<template>
  <div class="quiz-translator">
    <collapse accordion>
      <collapse-item title="Desafio Original" actived>
        <div class="columns" v-if="PlaceQuizes['pt'] && PlaceQuizes['pt'].length > 0">
          <div class="column" style="background-color: #efefef">
            <p>
              <b>Título:</b> {{PlaceQuizes['pt'][0].title}}
            </p>
            <p>
              <b>Descrição:</b> {{PlaceQuizes['pt'][0].description}}
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column"><hr /></div>
        </div>
        <div class="columns">
          <div class="column">
            <h4 class="is-title">Tradução para <b>{{quiz.language}}</b>:</h4>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <quiz-form
              :is-loading="isMainFormLoading"
              :is-disabled="isMainFormDisabled"
              button-label="Atualizar tradução"
              :form-data="quizData"
              :on-submit="update"
            />
          </div>
        </div>
      </collapse-item>
      <collapse-item
        title="Perguntas"
      >
        <div v-if="PlaceQuizes['pt'] && PlaceQuizes['pt'].length > 0">
          <div v-for="(a, index) in PlaceQuizes['pt'][0].answers" :key="index">
            <div class="columns" style="background-color: #efefef">
              <div class="column">
                <p><b>Texto: </b>{{a.text}}</p>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <h4 class="is-title">Tradução para <b>{{quiz.language}}</b>:</h4>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div>
                  <answer-translate-form
                    :form-data="answers[index] || { index }"
                    :button-label="answers[index] ? 'Atualizar Tradução' : 'Adicionar Tradução'"
                    :on-submit="answers[index] ? updateAnswer : saveAnswer"
                  >
                    <!-- <button
                      class="button is-danger is-large"
                      slot="buttons"
                      @click="deleteAnswer(answers[index])"
                    >
                    Apagar
                    </button> -->
                  </answer-translate-form>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column"><hr /></div>
            </div>
          </div>
        </div>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import QuizForm from './forms/QuizForm'
import AnswerTranslateForm from './forms/AnswerTranslateForm'
export default {
  name: 'QuizTranslateUpdater',
  components: { QuizForm, AnswerTranslateForm },
  props: {
    quiz: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isMainFormLoading: false,
    isMainFormDisabled: false,
    answerFormLoading: {},
    answerFormDisabled: {},
    quizData: {},
    answers: []
  }),
  computed: {
    ...mapGetters([
      'PlaceQuizes'
    ])
  },
  methods: {
    ...mapActions([
      'updateQuizTranslation',
      'translateQuizAnswer',
      'updateQuizAnswerTranslation'
    ]),
    async update (data) {
      const quizId = data.id
      const placeId = this.$route.params.id
      const id = data.languageId
      data = { title: data.title, description: data.description, language: data.language }
      // console.log({ data, id, placeId })
      try {
        this.isMainFormLoading = true
        this.isMainFormDisabled = true
        await this.updateQuizTranslation({ data, quizId, id, placeId })
        this.isMainFormLoading = false
        this.isMainFormDisabled = false
        this.$notify.open({
          type: 'success',
          content: 'Desafio traduzido com sucesso!',
          duration: 10000
        })
      } catch (error) {
        console.log(error)
        console.log(error.response)
        this.isMainFormLoading = false
        this.isMainFormDisabled = false
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível traduzir o Desafio.',
          duration: 10000
        })
      }
    },
    async updateAnswer (data) {
      const placeId = this.$route.params.id
      const quizId = this.PlaceQuizes['pt'][0].id
      const answerId = data.id
      const id = data.languageId
      data = { text: data.text, language: data.language }
      // console.log({data, id, quizId, placeId})
      try {
        await this.updateQuizAnswerTranslation({data, id, answerId, quizId, placeId})
        this.$notify.open({
          type: 'success',
          content: 'Resposta do Desafio traduzido com sucesso!',
          duration: 10000
        })
      } catch (error) {
        console.log(error)
        console.log(error.response)
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível traduzir a Resposta do Desafio.',
          duration: 10000
        })
      }
    },
    async saveAnswer (data) {
      const placeId = this.$route.params.id
      const quizId = this.PlaceQuizes['pt'][0].id
      const { index } = data
      delete data.index
      const id = this.PlaceQuizes['pt'][0].answers[index].id
      data.language = this.quiz.language
      console.log({data, id, quizId, placeId})
      try {
        this.answerFormLoading[index] = true
        this.answerFormDisabled[index] = true
        await this.translateQuizAnswer({data, id, quizId, placeId})
        this.answerFormLoading[index] = false
        this.$notify.open({
          type: 'success',
          content: 'Resposta do Desafio traduzido com sucesso!',
          duration: 10000
        })
      } catch (error) {
        this.answerFormLoading[index] = false
        this.answerFormDisabled[index] = false
        console.log(error)
        console.log(error.response)
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível traduzir a Resposta do Desafio.',
          duration: 10000
        })
      }
    }
  },
  watch: {
    quiz (data) {
      if (data) {
        this.quizData = { ...data }
        this.answers = data.answers || []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QuizTranslateUpdater.vue